const generateExpressionCondition = (
  question,
  responseValue,
  operator,
  value
) => {
  if (["exist", "not exist"].includes(operator)) {
    if (typeof responseValue !== "undefined") {
      return operator === "exist" ? "true" : "false";
    } else {
      return operator === "exist" ? "false" : "true";
    }
  }

  if (
    !question ||
    (!responseValue && responseValue !== false && responseValue !== 0) ||
    !operator ||
    (!value && value !== false && value !== 0)
  ) {
    return "false";
  }

  const stringValue = JSON.stringify(value);

  const stringResponseValue = JSON.stringify(responseValue);

  if (question?.input_type === "multi_select") {
    if (operator === "===") {
      return `${stringResponseValue}.indexOf(${stringValue}) >= 0`;
    } else {
      return `${stringResponseValue}.indexOf(${stringValue}) < 0`;
    }
  }

  if (operator === "in") {
    return `${stringValue}.indexOf(${JSON.stringify(responseValue)}) >= 0`;
  }

  if (operator === "not in") {
    return `${stringValue}.indexOf(${JSON.stringify(responseValue)}) < 0`;
  }

  return `${stringResponseValue} ${operator} ${stringValue}`;
};

export default generateExpressionCondition;
